const firebaseConfig = {
  apiKey: "AIzaSyCyxWKsLq0Kl1nIdEi7_DrmuhTT_bcwj7s",
  authDomain: "travel-guru-cd64a.firebaseapp.com",
  databaseURL: "https://travel-guru-cd64a.firebaseio.com",
  projectId: "travel-guru-cd64a",
  storageBucket: "travel-guru-cd64a.appspot.com",
  messagingSenderId: "992505487481",
  appId: "1:992505487481:web:e27fb66377ecc9b65af4a8"
};
  export default firebaseConfig ;

 